module.exports = __webpack_public_path__ + "img/001-man.297b6c8d.png";